import { IcoFeedbackError, IcoInfoCircle } from "assets/icons";
import favicon from "assets/icons/favicon.png";
import logo from "assets/images/ccr-highwys-logo-wide.svg";
import colors from "colors";
import { Helmet } from "react-helmet-async";
import { Constants } from "../../../appConstants";

export default function UserNotFound() {
	return (
		<>
			<Helmet>
				<title>{`${process.env.REACT_APP_TITLE} - Backoffice - Email não cadastrado`}</title>
				<link rel="shortcut icon" href={favicon} type="image/x-icon" />
				<link rel="icon" href={favicon} type="image/x-icon" />
			</Helmet>
			<div className="h-full w-full flex justify-center bg-neutral-low-pure-500">
				<div className="flex flex-col gap-16 mt-[20vh] items-center">
					<img src={logo} alt="logo-icon" className="logo" />
					<div className="bg-neutral-high-pure-50 p-10 w-[26.5rem] rounded-lg max-sm:w-[18rem] max-sm:py-6">
						<IcoFeedbackError />
						<p className="text-2xl leading-5 font-semibold py-4">
							{Constants.strings.pages.userNotFound.email}
						</p>
						<p className="pb-6">
							{Constants.strings.pages.userNotFound.permission}
						</p>
						<div className="flex items-center bg-neutral-high-100 gap-4 p-4 rounded-lg">
							<div>
								<IcoInfoCircle color={colors.neutral["low-pure-500"]} />
							</div>
							<p className="text-xs">
								{Constants.strings.pages.userNotFound.requestCCR}
							</p>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
